// extracted by mini-css-extract-plugin
export var connectionButton = "_4j-1";
export var rightPanel = "_4j-3";
export var stepDescription = "_4j-2";
export var stepIcon = "_4j-0";